/* Theme system: C is mutated in place by applyTheme; shared style objects use
   getters so every render reads the live palette. */
const THEMES = {
  athenaeum: {
    label: "Athenaeum", desc: "night library, brass instruments (default)",
    font: "'Avenir Next','Segoe UI',system-ui,sans-serif",
    displayFont: "'Cormorant Garamond',Georgia,serif",
    bg: "#0d1120", surface: "#161c2e", surface2: "#1e2640", line: "#2b3450",
    text: "#e9e3d3", dim: "#9298ac", faint: "#5c637c", brass: "#c9a45c",
    fire: "#c96a4e", earth: "#86a06e", air: "#d3b761", water: "#6e9cc4", rose: "#e58a9b",
    lotColors: { Spirit: "#e3b34c", Fortune: "#c0c6d4", Eros: "#e58a9b",
      Necessity: "#b79bff", Courage: "#c96a4e", Victory: "#8fbc8f",
      Nemesis: "#7d8aa5", Death: "#9a9a8f" },
  },
  alexandria: {
    label: "Alexandria", desc: "aged parchment and iron-gall ink",
    font: "'EB Garamond',Georgia,serif",
    displayFont: "'Cormorant Garamond',Georgia,serif",
    bg: "#e8dec5", surface: "#f2ead6", surface2: "#e2d5b4", line: "#c6b48a",
    text: "#3a2f1b", dim: "#6b5c3e", faint: "#94835f", brass: "#8a5a24",
    fire: "#a34d2e", earth: "#5f7040", air: "#9a7d23", water: "#3e6e8c", rose: "#a1495f",
    lotColors: { Spirit: "#9a7d23", Fortune: "#6b5c3e", Eros: "#a1495f",
      Necessity: "#6d5a8e", Courage: "#a34d2e", Victory: "#5f7040",
      Nemesis: "#57636f", Death: "#7a6f52" },
  },
  meridian: {
    label: "Meridian", desc: "bright, modern, indigo",
    font: "'Inter','Segoe UI',system-ui,sans-serif",
    displayFont: "'Inter','Segoe UI',system-ui,sans-serif",
    bg: "#f6f7fb", surface: "#ffffff", surface2: "#edf0f7", line: "#dde3ef",
    text: "#182038", dim: "#5b6478", faint: "#99a1b5", brass: "#4f46e5",
    fire: "#ea580c", earth: "#16a34a", air: "#ca8a04", water: "#0284c7", rose: "#e11d48",
    lotColors: { Spirit: "#ca8a04", Fortune: "#64748b", Eros: "#e11d48",
      Necessity: "#7c3aed", Courage: "#ea580c", Victory: "#16a34a",
      Nemesis: "#475569", Death: "#78716c" },
  },
  grimoire: {
    label: "Grimoire", desc: "candle-lit violet, antique gold, a little blood",
    font: "'Avenir Next','Segoe UI',system-ui,sans-serif",
    displayFont: "'Cinzel',Georgia,serif",
    bg: "#0b0a12", surface: "#151024", surface2: "#1e1634", line: "#352755",
    text: "#d9d2e9", dim: "#9b8fc0", faint: "#5f5480", brass: "#b28f4f",
    fire: "#b0413e", earth: "#6d8a5b", air: "#b89b4e", water: "#5b7fa6", rose: "#c74e6e",
    lotColors: { Spirit: "#b89b4e", Fortune: "#9b8fc0", Eros: "#c74e6e",
      Necessity: "#8a6fc4", Courage: "#b0413e", Victory: "#6d8a5b",
      Nemesis: "#6a6296", Death: "#8d8577" },
  },
};

export const THEME_LIST = Object.entries(THEMES).map(([k, v]) =>
  ({ key: k, label: v.label, desc: v.desc, swatch: [v.bg, v.surface, v.brass, v.text] }));

export const C = {};
export function applyTheme(key) {
  const t = THEMES[key] || THEMES.athenaeum;
  const { lotColors, label, desc, ...colors } = t;
  Object.keys(C).forEach((k) => delete C[k]);
  Object.assign(C, colors, { lotColors });
  try { localStorage.setItem("ac_theme", key); } catch {}
  document.body.style.background = C.bg;
}
export const currentTheme = () => {
  try { return localStorage.getItem("ac_theme") || "athenaeum"; } catch { return "athenaeum"; }
};
applyTheme(currentTheme());

export const SIGNS = ["Aries","Taurus","Gemini","Cancer","Leo","Virgo",
  "Libra","Scorpio","Sagittarius","Capricorn","Aquarius","Pisces"];
export const GLYPH = { Aries:"\u2648",Taurus:"\u2649",Gemini:"\u264A",Cancer:"\u264B",
  Leo:"\u264C",Virgo:"\u264D",Libra:"\u264E",Scorpio:"\u264F",Sagittarius:"\u2650",
  Capricorn:"\u2651",Aquarius:"\u2652",Pisces:"\u2653" };
export const PLANET_GLYPH = { Sun:"\u2609",Moon:"\u263D",Mercury:"\u263F",Venus:"\u2640",
  Mars:"\u2642",Jupiter:"\u2643",Saturn:"\u2644",Uranus:"\u2645",Neptune:"\u2646",
  Pluto:"\u2647",TrueNode:"\u260A" };
export const ELEMENT_COLOR = (s) =>
  [C.fire, C.earth, C.air, C.water][SIGNS.indexOf(s) % 4];
export const LOTS = ["Spirit","Fortune","Eros","Necessity","Courage","Victory","Nemesis","Death"];
export const LOT_COLORS = new Proxy({}, { get: (_o, k) => C.lotColors?.[k] });
export const card = {
  get background() { return C.surface; },
  get border() { return `1px solid ${C.line}`; },
  borderRadius: 8, padding: "16px 18px",
};
export const label = {
  fontSize: 10, letterSpacing: "0.16em", marginBottom: 8,
  get color() { return C.faint; },
};
export const btn = (primary = true) => ({
  background: primary ? C.brass : C.surface2, color: primary ? C.bg : C.text,
  border: primary ? "none" : `1px solid ${C.line}`, borderRadius: 4, padding: "8px 18px",
  fontWeight: primary ? 700 : 400, fontSize: 13, cursor: "pointer", fontFamily: "inherit" });
export const input = {
  get background() { return C.surface2; },
  get color() { return C.text; },
  get border() { return `1px solid ${C.line}`; },
  borderRadius: 4, padding: "7px 10px", fontSize: 13, fontFamily: "inherit",
};
